module.exports = __webpack_public_path__ + "static/media/medico-central-home.24c3ce20.png";